export const isTermsAndConditionsLoading = (state) => {
  var _a, _b;
  return (_b = (_a = state == null ? void 0 : state.requestRights) == null ? void 0 : _a.termsAndConditions) == null ? void 0 : _b.isFetching;
};
export const isRequestRightsLoading = (state) => {
  var _a;
  return (_a = state == null ? void 0 : state.requestRights) == null ? void 0 : _a.isFetching;
};
